exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app {\n  font-family: 'Asap', sans-serif !important;\n  margin-top: 30px;\n}\n", ""]);

// exports
